import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService, BaseComponent } from '@app/core';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'reset-password-dialog',
  templateUrl: 'reset-password-dialog.component.html',
})
export class ResetPasswordDialogComponent
  extends BaseComponent
  implements OnInit
{
  isLoading = false;
  resetForm!: UntypedFormGroup;
  message!: string;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
  ) {
    super();
    this.createResetForm();
  }

  ngOnInit(): void {}

  reset() {
    this.isLoading = true;
    this.addSubscription(
      this.authenticationService.resetPasswordRequest(this.resetForm.value),
    ).subscribe((res) => {
      if (res) {
        this.isLoading = false;
        this.message = res.data.message;
      }
    });
  }

  private createResetForm() {
    this.resetForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
